import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { InstallPrompter } from "@/components/landing/InstallPrompter";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { FilmsProvider } from "@/context/FilmsContext";
import Landing from "@/components/landing/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Archive from "@/pages/Archive";
import Watch from "@/pages/Watch";
import AuthCallback from "@/pages/AuthCallback";

let launchedInApp = false;

function AppRouter() {
  const location = useLocation();
  // Process the OAuth session_id FIRST (synchronously) before any routes render.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Installed app (PWA/TWA) launch: go straight to the Archive (Continue Watching),
  // once per launch — manual navigation to "/" later still shows the landing page.
  const isStandalone =
    typeof window !== "undefined" &&
    (window.matchMedia?.("(display-mode: standalone)").matches ||
      window.navigator.standalone === true);
  if (isStandalone && !launchedInApp && location.pathname === "/") {
    launchedInApp = true;
    return <Navigate to="/archive" replace />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/archive" element={<Archive />} />
      <Route path="/watch/:id" element={<Watch />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-background text-foreground">
      <div className="grain-overlay" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#e8e2d6",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "12px",
            borderRadius: "0",
          },
        }}
      />
      <AuthProvider>
        <FilmsProvider>
          <BrowserRouter>
            <InstallPrompter />
            <AppRouter />
          </BrowserRouter>
        </FilmsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
